<template>
  <el-container class="CollectForm">
    <el-main class="p-0">
      <el-form
        ref="form"
        label-width="80px"
        class="form-label-90"
        :model="data"
        :rules="rules"
        :inline="false"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="수금일" prop="collect_date" class="block">
              <ADatePicker v-model="data.collect_date" :clearable="false" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="수금방법"
              prop="collect_way_flag"
              class="block"
            >
              <ASelector
                labelField="label"
                valueField="value"
                :items="collect_way_flag_options"
                v-model="data.collect_way_flag_temp"
                @change="handleChangeCollectWayFlag"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="수금액" prop="price" class="block">
              <ANumberInput v-model="data.price" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="할인액" prop="discount_price" class="block">
              <ANumberInput v-model="data.discount_price" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="비고" prop="desc" class="block">
              <el-input v-model="data.desc" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="!has_grant_write"
        :loading="load_button"
        @shortkey.native="clickSave"
        @click="clickSave"
        >{{ data.id > 0 ? "수정" : "등록" }} (F4)</el-button
      >
      <el-button
        type="danger"
        v-if="data.id > 0"
        :disabled="!has_grant_write"
        :loading="load_button"
        @click="clickDelete"
        >삭제</el-button
      >
      <el-button class="right" @click="closeDialog"
        >{{ $t("button.close") }} (Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
import { form } from "@/common/mixins/form";
import { account_form } from "@/common/mixins/account_form";

export default {
  name: "CollectForm",
  mixins: [form, account_form],
  data() {
    return {
      title: this.$t("title.collection"),
      rules: {
        collect_date: [
          {
            required: true,
            message: "수금일을 입력해 주세요.",
            trigger: "blur",
          },
        ],
        collect_way_flag: [
          {
            required: true,
            message: "수금방법을 선택해 주세요.",
            trigger: "blur",
          },
        ],
        price: [{ required: true, message: "수금액을 입력해 주세요." }],
      },
      working: false,
      load_button: false,
    };
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      default: function() {
        return {
          title: this.$t("title.collection"),
          id: 0,
          collect_date: this.util.getDateString(),
          collect_way_flag: "1",
          collect_way_flag_temp: "1",
          price: null,
          discount_price: 0,
          created_at: null,
          last: false,
        };
      },
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    collect_way_flag_options: function() {
      // deep copy
      let collect_list = JSON.parse(
        JSON.stringify(this.system.options.collect_way_flag)
      );
      // '통장' item 삭제
      collect_list.splice(1, 1);
      return this.convert_bankbook_options(collect_list, 2);
    },
  },
  methods: {
    /** 저장 */
    clickSave() {
      if (!this.has_grant_write) {
        return;
      }
      if (this.working) {
        return;
      }
      this.load_button = true;
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.working = true;
        if (this.data.id > 0) {
          this.doUpdate();
        } else {
          this.doCreate();
        }
      });
    },
    /** 삭제 */
    clickDelete() {
      if (this.data.id < 1) {
        this.util.notify_warning(this, this.title, "저장된 데이타가 아닙니다.");
        return;
      }
      /** 삭제 */
      this.util.confirm_delete(this, this.title, this.doDelete);
    },

    // convert_collect_way_flag() {
    //   // 수금방법에서 통장관련 아이템이 선택된 경우 처리
    //   let account_data = this.data.collect_way_flag.split('-');
    //   if( account_data.length > 1 ) {
    //     this.data.collect_way_flag = account_data[0];
    //     this.data.account_id = account_data[1];
    //   }
    // },

    doCreate() {
      this.data.customer_id = this.customer.id;
      this.data.customer_name = this.customer.name;

      // this.convert_collect_way_flag();

      this.api.createCollect(this.data).then((res) => {
        this.load_button = false;
        this.working = false;
        this.handleResult(res, this.$t("message.success_create"));
      });
    },

    doUpdate() {
      this.data.customer_id = this.customer.id;
      this.data.customer_name = this.customer.name;

      // this.convert_collect_way_flag();

      this.api.updateCollect(this.data).then((res) => {
        this.load_button = false;
        this.working = false;
        this.handleResult(res, this.$t("message.success_update"));
      });
    },

    doDelete() {
      this.load_button = true;
      this.api.deleteCollect(this.data).then((res) => {
        this.load_button = false;
        this.handleResult(res, this.$t("message.success_delete"));
      });
    },
    handleResult(res, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, message);
      this.$emit("completed", true);
    },
    handleChangeCollectWayFlag() {
      this.onChangeCollectWayFlag(this.data);
    },
  },
};
</script>
